var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "couponProList sub-main" }, [
    _c("div", { staticClass: "banxin" }, [
      _c("div", { staticClass: "bannerBox" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", [
            _vm.noData
              ? _c("div", { staticClass: "noproduct" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/image/noorder@2x.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs20 font-color-999" }, [
                    _vm._v("该优惠券没有可用商品～")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("h3", [_vm._v("优惠券可用商品列表")]),
                _vm._v(" "),
                _c("ProductList", { attrs: { productList: _vm.productList } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.productList.length > 0
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-size": 15,
                  background: "",
                  layout: "prev, pager, next",
                  total: _vm.total
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-326b71de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-326b71de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/couponProlist/index.vue
// module id = null
// module chunks = 